var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.0156 2.77881C15.4101 0.439715 19.3119 0.440138 21.7061 2.77979C22.8647 3.91197 23.5 5.41281 23.5 7.00928C23.5 8.50589 22.9416 9.91841 21.917 11.022L21.7061 11.2388C20.5471 12.3716 19.0057 12.9965 17.3613 12.9966C15.9455 12.9969 14.6065 12.5311 13.5215 11.6792L13.1768 11.4087L12.8633 11.7144L4.91406 19.4819L4.54883 19.8394L4.91406 20.1968L6.83984 22.0796H6.84082C6.88346 22.1211 6.90231 22.1729 6.90234 22.2241C6.90234 22.2748 6.88314 22.3273 6.83984 22.3696C6.76116 22.4461 6.63649 22.4552 6.54688 22.3979L6.51074 22.3696L4.58496 20.4868L4.23535 20.146L3.88574 20.4868L2.74512 21.6021L2.37891 21.9595L2.74512 22.3169L4.12891 23.6694C4.17191 23.7117 4.19141 23.7634 4.19141 23.814C4.19139 23.8651 4.17205 23.9173 4.12891 23.9595C4.05029 24.0363 3.92635 24.0452 3.83691 23.9878L3.80078 23.9595L2.41895 22.6069L2.06836 22.2651L1.71875 22.6079L0.880859 23.4292C0.791099 23.5169 0.646401 23.5169 0.556641 23.4292L0.532227 23.3999C0.483501 23.3274 0.485123 23.2196 0.567383 23.1392L1.94531 21.8179L2.09863 21.6704V21.6431L4.07129 19.6938L4.10645 19.6597V19.6587L12.5332 11.4253L12.8613 11.104L12.5693 10.7495C11.6966 9.68997 11.2217 8.3863 11.2217 7.00928C11.2217 5.41286 11.8562 3.91173 13.0156 2.77881ZM21.377 3.06982C19.2306 0.972527 15.7853 0.906577 13.5576 2.87256L13.3457 3.06982C12.2712 4.11905 11.6768 5.52006 11.6768 7.00928C11.6768 8.49895 12.2713 9.89986 13.3457 10.9497C14.4194 11.9988 15.8476 12.5747 17.3613 12.5747C18.8748 12.5747 20.3021 11.9977 21.376 10.9487C22.45 9.89923 23.0449 8.49891 23.0449 7.00928C23.0449 5.51966 22.4504 4.11929 21.377 3.06982Z",
      "fill": "#0070B6",
      "stroke": "#0070B6"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }